<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="mt-1 relative">
        <div v-if="!searchable" class="flex items-center border border-gray-300 rounded-md" @click="search">
            <span
                class="
                    relative
                    w-full
                    bg-white
                    rounded-md
                    shadow-sm
                    pl-3
                    pr-10
                    text-left
                    cursor-default
                    focus:outline-none
                    focus:ring-1 focus:ring-indigo-500
                    focus:border-indigo-500
                    py-2
                    sm:text-sm
                "
                >{{ selected ? selected.name : content.length ? content[0][keyName] : "Unknown" }}
            </span>
            <div class="bg-gray-200 w-auto h-full p-2 flex-grow mx-auto">
                <fa-icon icon="chevron-down"></fa-icon>
            </div>
        </div>
        <div v-else class="">
            <input
                id="search-input"
                v-model="searchTerm"
                type="text"
                :placeholder="$t('airtable.forms.airtable_record.title')"
                class="
                    relative
                    w-full
                    bg-white
                    border border-gray-300
                    rounded-md
                    shadow-sm
                    pl-3
                    pr-10
                    text-left
                    cursor-default
                    focus:outline-none
                    focus:ring-1 focus:ring-indigo-500
                    focus:border-indigo-500
                    sm:text-sm
                "
                @keyup.prevent.enter="search"
                @keydown.prevent.down
            />
        </div>
        <div v-if="content.length && showResults" class="max-h-64 h-64 overflow-y-scroll">
            <div
                v-for="(item, index) in content"
                :key="index"
                class="bg-gray-100 hover:bg-gray-300 flex justify-between rounded p-4 my-2 text-sm"
                @click="selectItem(item)"
            >
                <div class="">
                    <h5 class="text-gray-800">{{ item[keyName] }}</h5>
                </div>
                <div class="flex flex-row">
                    <p class="text-gray-800 my-auto mx2">{{}}</p>
                    <div class="h-3 w-3 rounded-full mx-2 my-auto"></div>
                </div>
            </div>
        </div>
        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"> </span>
    </div>
</template>

<script>
import { computed, ref } from "vue";
import FaIcon from "@/Components/FaIcon";

export default {
    name: "SelectMenu",
    components: {
        FaIcon,
    },
    props: {
        content: Array,
        keyName: String,
        title: String,
        searchable: {
            type: Boolean,
            default: false,
        },
        preSelectedItem: {
            type: Object,
            required: false,
        },
    },
    emits: ["SelectItem", "SearchInput"],
    setup(props, context) {
        const selected = ref(null);
        const options = computed(() => document.getElementById("options"));
        const searchTerm = ref(null);
        const showResults = ref(false);

        const search = () => {
            context.emit("SearchInput", searchTerm.value);

            showResults.value = true;
        };

        const selectItem = (item) => {
            selected.value = item;
            if (props.searchable) {
                searchTerm.value = item[props.keyName];
            }

            showResults.value = false;
            context.emit("SelectItem", item);
        };

        return {
            search,
            selectItem,
            options,
            searchTerm,
            selected,
            showResults,
        };
    },
};
</script>
